<template>
    
    <b-modal
        id="poll-modal"
        ref="poll-modal"
        :title-html="data.question"
        :title-class="['h4','text-white']"
        centered
        :hide-header-close="true"
        :cancel-disabled="true"
        :ok-disabled="true"
        size="md"
        header-bg-variant="info"
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
    >
        <div class="ans-cnt">
            <div 
                v-for="(a,index) in data.survey" 
                :key="index" 
                :class="{ ans: true, [a.custom_class]: (a.custom_class) }">
                <div :class="{ 'ans-no-vote noselect': true, active: a.selected }" @click.prevent="handleVote(a)" >
                    <h4 class="txt" v-html="a.text"></h4>
                </div>
            </div>
        </div>
        <template v-if="data.multiple === 1 && totalSelections > 0">
            <b-button @click.prevent="handleMultiple" variant="primary" class="float-right">{{this.data.submit_text}}</b-button>
        </template>
    </b-modal>
    
</template>

<script>
    import Vue from 'vue'
    export default Vue.extend({
        name: 'Poll',
        props: {
            data: { type: Object, default: () => ({}) },
            assistant: { type: Object, default: () => ({}) },
        },
        data(){
            return{
                answers: []
            }
        },
        computed: {           
            totalSelections(){
                return this.data.survey.filter(a => a.selected).length
            },
            cssVars() {
                return {
                    '--primary': this.primary,
                    '--secondary': this.secondary
                }
            }
        },
        methods: {
            voteSubmit(poll_answers) {
                let loader = this.$loading.show()
                this.errors = []
                let url = '/catalog/polls/'+this.data.id+'/vote?_method=PUT'
                let method = 'post'
                this.$store.dispatch(method, {'url':url, data: {poll_answers: poll_answers, assistant_key_id:this.assistant.key_id}, headers:{}})
                    .then((resp) => {
                        loader.hide()
                        this.$nextTick(() => {
                            this.hiddenModal()
                        })
                    })
                    .catch(err => {
                        loader.hide()
                        this.$nextTick(() => {
                            this.hiddenModal()
                        })
                    })
            },
            showModal() {
                this.$bvModal.show('poll-modal')
            },
            hiddenModal(msg) {
                if(msg) this.$emit('closed', msg)
                else this.$emit('closed')
            },
            handleMultiple(){
                let selected = this.data.survey.filter(a => a.selected)
                let answer = []
                selected.forEach(element => {
                    answer.push({id: element.id})
                });
                this.voteSubmit(answer)

            },
            handleVote(a){ //Callback
                if (this.data.multiple === 1){
                    if (a.selected === undefined)
                        console.log("Please add 'selected: false' on the answer object")
                    a.selected = !a.selected
                    return
                }

                let answer = [{id: a.id}]
                this.voteSubmit(answer)
            }
        },
        mounted() {
            this.showModal()
        },
    })

</script>

<style lang="scss" scoped>

    #poll-modal{        
      font-family: 'Avenir', Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      color: #2c3e50;
    }
    
    #poll-modal .noselect {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    
    #poll-modal .qst{
        font-weight: normal;
    }
    #poll-modal .ans-cnt{
         margin: 20px 0;   
    }
    #poll-modal .ans-cnt .ans{
        position: relative;
        margin-top: 10px;
    }
    #poll-modal .ans-cnt .ans:first-child{
        margin-top: 0;
    }
    
    #poll-modal .ans-cnt .ans-no-vote{
        text-align: center;
        border: 2px solid var(--success);
        box-sizing: border-box;
        border-radius: 5px;
        cursor:pointer; 
        padding: 5px 0; 
        transition: background .2s ease-in-out;
        -webkit-transition: background .2s ease-in-out;
        -moz-transition: background .2s ease-in-out;
    }
    
    #poll-modal .ans-cnt .ans-no-vote .txt{
        color: var(--dark);
        transition: color .2s ease-in-out;
        -webkit-transition: color .2s ease-in-out;
        -moz-transition: color .2s ease-in-out;
    }

    #poll-modal .ans-cnt .ans-no-vote:hover{
        background: var(--success);
    }
    
    #poll-modal .ans-cnt .ans-no-vote.active{
        background: var(--success);
    }
    
    #poll-modal .ans-cnt .ans-no-vote.active .txt{
        color: #fff;
    }
    
    #poll-modal .ans-cnt .ans-voted{
        padding: 5px 0;
    }
    
    #poll-modal .ans-cnt .ans-voted .percent,
    #poll-modal .ans-cnt .ans-voted .txt{
        position: relative;
        z-index: 1;
    }
    #poll-modal .ans-cnt .ans-voted .percent{
        font-weight: bold;
        min-width: 51px;
        display: inline-block;
        margin:0 10px;
    }
	
	#poll-modal .ans-cnt .ans-voted.selected .txt:after{
		content:'✔';
		margin-left: 10px;
	}
           
    #poll-modal .ans-cnt .ans .bg{
        position: absolute;
        width: 0%;
        top: 0;
        left: 0;
        bottom: 0;
        z-index: 0;
        background-color: #E1E8ED;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        transition: all .3s cubic-bezier(0.5,1.2,.5,1.2);
        -webkit-transition: all .3s cubic-bezier(0.5,1.2,.5,1.2);
        -moz-transition: all .3s cubic-bezier(0.5,1.2,.5,1.2);
    }
    
    #poll-modal .ans-cnt .ans .bg.selected{
        background-color: var(--success);
    }
    
    #poll-modal .votes{
        font-size: 14px;
        color:var(--light)
    }
    
    #poll-modal .submit{
        display: block;
        text-align: center;
        margin: 0 auto;
        max-width: 80px;
        text-decoration: none;
        background-color: var(--success);
        color:#fff;
        padding: 10px 25px;
        border-radius: 5px;
        
    }
</style>
